export type SharePayload = {
  title: string;
  text: string;
  url: string;
};

export async function shareContent(payload: SharePayload) {
  if (navigator.share) {
    await navigator.share(payload);
    return 'shared';
  }

  await navigator.clipboard.writeText(payload.url);
  return 'copied';
}

export function createWhatsAppUrl(payload: SharePayload) {
  return `https://wa.me/?text=${encodeURIComponent(`${payload.title} ${payload.url}`)}`;
}

export function createXUrl(payload: SharePayload) {
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(payload.title)}&url=${encodeURIComponent(
    payload.url
  )}`;
}
